import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("선물함")
const _hoisted_3 = {
  id: "content",
  class: "content"
}
const _hoisted_4 = { class: "product_notice_area" }
const _hoisted_5 = { class: "product_notice_bx" }
const _hoisted_6 = { class: "btn_area" }
const _hoisted_7 = {
  class: "dimmed",
  style: {"display":"block"}
}
const _hoisted_8 = /*#__PURE__*/_createVNode("strong", { class: "txt" }, "기한 연장", -1)
const _hoisted_9 = { class: "sub_txt" }
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("strong", { class: "txt" }, "유효기간 연장이 완료되었습니다.", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("strong", { class: "txt" }, "교환권을 앨범에 저장했습니다.", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("strong", { class: "txt" }, "선물 삭제", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "sub_txt" }, [
  /*#__PURE__*/_createTextVNode("선물을 삭제하시겠습니까? "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("삭제 완료 시, 지난 선물목록으로 이동합니다.")
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("strong", { class: "txt" }, "선물 삭제를 완료하였습니다.", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("strong", { class: "txt" }, "나도 선물하기", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("p", { class: "sub_txt" }, [
  /*#__PURE__*/_createTextVNode("선물하기 메인 화면으로 이동합니다. "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("선물하기에서 상품 선택 후 선물하기 버튼 터치 시 받는사람이 자동 선택됩니다.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_component = _resolveComponent("header-component")
  const _component_ticket_message_component = _resolveComponent("ticket-message-component")
  const _component_ticket_info_component = _resolveComponent("ticket-info-component")
  const _component_information_component = _resolveComponent("information-component")
  const _component_product_usage_component = _resolveComponent("product-usage-component")
  const _component_to_top = _resolveComponent("to-top")
  const _component_popup_component = _resolveComponent("popup-component")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      id: "wrap",
      class: ["wrap", {app_view: _ctx.isApp}]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_header_component, null, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: ["gift_box_detail_area", _ctx.badgeForTicketStatus]
        }, [
          (_ctx.loadingCompleted)
            ? (_openBlock(), _createBlock(_component_ticket_message_component, {
                key: 0,
                productImageUrl: _ctx.product.productImageUrl,
                message: _ctx.order.message,
                ordererName: _ctx.order.ordererName
              }, null, 8, ["productImageUrl", "message", "ordererName"]))
            : _createCommentVNode("", true),
          (_ctx.loadingCompleted)
            ? (_openBlock(), _createBlock(_component_ticket_info_component, {
                key: 1,
                ticket: _ctx.ticket,
                product: _ctx.product,
                approval: _ctx.approval,
                onToggleExtendingPopup: _ctx.toggleExtendingPopup,
                onToggleRefusingPopup: _ctx.toggleRefusingPopup
              }, null, 8, ["ticket", "product", "approval", "onToggleExtendingPopup", "onToggleRefusingPopup"]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_information_component, { items: _ctx.InformationArray }, null, 8, ["items"]),
              _createVNode(_component_product_usage_component, {
                product: _ctx.product,
                isForTicketDetail: true
              }, null, 8, ["product"])
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            (_ctx.ticket.isUsable
                    && _ctx.ticket.canDownloadTicket
                    && !_ctx.isApp)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.downloadTicket && _ctx.downloadTicket(...args))),
                  class: "btn btn_default full_width"
                }, " 앨범에 저장하기 "))
              : _createCommentVNode("", true),
            (_ctx.isDeletable)
              ? (_openBlock(), _createBlock("button", {
                  key: 1,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleDeletingPopup && _ctx.toggleDeletingPopup(...args))),
                  type: "button",
                  class: "btn btn_full"
                }, "삭제"))
              : _createCommentVNode("", true),
            (_ctx.ticket.isUsable)
              ? (_openBlock(), _createBlock("button", {
                  key: 2,
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleSendingPopup && _ctx.toggleSendingPopup(...args))),
                  type: "button",
                  class: "btn btn_full"
                }, "나도 선물하기"))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ]),
      _createVNode(_component_to_top)
    ], 2),
    _withDirectives(_createVNode("div", _hoisted_7, null, 512), [
      [_vShow, _ctx.showDimmed]
    ]),
    _withDirectives(_createVNode(_component_popup_component, {
      onConfirm: _ctx.confirmExtending,
      showCancelButton: true
    }, {
      default: _withCtx(() => [
        _hoisted_8,
        _createVNode("p", _hoisted_9, [
          _createTextVNode(_toDisplayString(_ctx.product.brandName) + " " + _toDisplayString(_ctx.product.productName) + " 교환권의 유효기한을 연장합니다.", 1),
          _hoisted_10,
          _createTextVNode("기한 연장 시, " + _toDisplayString(_ctx.extendedValidityString) + "까지 사용 가능합니다.", 1)
        ])
      ]),
      _: 1
    }, 8, ["onConfirm"]), [
      [_vShow, _ctx.showExtendingPopup]
    ]),
    _withDirectives(_createVNode(_component_popup_component, { onConfirm: _ctx.confirmExtendingCompletionPopup }, {
      default: _withCtx(() => [
        _hoisted_11
      ]),
      _: 1
    }, 8, ["onConfirm"]), [
      [_vShow, _ctx.showExtendingCompletionPopup]
    ]),
    _withDirectives(_createVNode(_component_popup_component, { onConfirm: _ctx.toggleSavingCompletionPopup }, {
      default: _withCtx(() => [
        _hoisted_12
      ]),
      _: 1
    }, 8, ["onConfirm"]), [
      [_vShow, _ctx.showSavingCompletionPopup]
    ]),
    _withDirectives(_createVNode(_component_popup_component, {
      onConfirm: _ctx.confirmDeleting,
      showCancelButton: true
    }, {
      default: _withCtx(() => [
        _hoisted_13,
        _hoisted_14
      ]),
      _: 1
    }, 8, ["onConfirm"]), [
      [_vShow, _ctx.showDeletingPopup]
    ]),
    _withDirectives(_createVNode(_component_popup_component, { onConfirm: _ctx.toggleDeletingCompletionPopup }, {
      default: _withCtx(() => [
        _hoisted_15
      ]),
      _: 1
    }, 8, ["onConfirm"]), [
      [_vShow, _ctx.showDeletingCompletionPopup]
    ]),
    _withDirectives(_createVNode(_component_popup_component, {
      onConfirm: _ctx.confirmSending,
      showCancelButton: true
    }, {
      default: _withCtx(() => [
        _hoisted_16,
        _hoisted_17
      ]),
      _: 1
    }, 8, ["onConfirm"]), [
      [_vShow, _ctx.showSendingPopup]
    ])
  ], 64))
}